export const autoExtract = (data, name) => {
  const value = data?.[name];
  return typeof value === 'string' ||
    typeof value === 'bigint' ||
    typeof value === 'number'
    ? value
    : null;
};
//# sourceMappingURL=autoExtract.js.map
